'use client';

import { Button } from '@petsmart-ui/sparky';
import { useRouter } from 'next/navigation';
import { type MouseEvent } from 'react';
import { useShallow } from 'zustand/shallow';

import { trackClickContinueShopping } from '@libs/analytics';

import { useCartConfirmDrawer } from './model/useCartConfirmDrawer';

export const Footer = ({ onCloseAll }: { onCloseAll?: () => void } = {}) => {
    const router = useRouter();
    const { close, content } = useCartConfirmDrawer(
        useShallow(store => ({
            close: store.close,
            content: store.content,
        }))
    );

    const handleContinueShopping = () => {
        trackClickContinueShopping();
        content.secondaryAction?.onClick?.();
        close();
        onCloseAll?.();
    };

    const handlePrimaryAction = (event: MouseEvent) => {
        event.preventDefault();
        content.primaryAction?.onClick?.();
        router.push(content.primaryAction?.href ?? '/cart');
    };

    return (
        <>
            <Button
                fullWidth
                type="button"
                text={content.secondaryAction?.text ?? 'Continue shopping'}
                onClick={handleContinueShopping}
            />
            <Button
                fullWidth
                type="button"
                variant="primary"
                onClick={handlePrimaryAction}
                text={content.primaryAction?.text ?? 'View cart and checkout'}
            />
        </>
    );
};
